import { AlertError, AlertErrorAction, CoreError, TechnicalErrorIdentifier } from "@archipad-js/core/error";
import { LocalizationService } from "@archipad-js/core/translate";

/**
 * Isolated subset of the legacy `TechnicalErrorModule` used by the librarised
 * archipad project errors. The string values must stay in sync with the legacy
 * enum so that the error identifiers remain stable.
 */
const enum ArchipadTechnicalErrorModule {
    PATCHES = "Patches",
    PROJECT = "Project",
}

export class PatchTooOldError extends CoreError {
    public override identifier = new TechnicalErrorIdentifier(ArchipadTechnicalErrorModule.PATCHES, "PATCH_TOO_OLD");
}

export class VisitTypeSystemMissingError extends AlertError {
    public static identifier = new TechnicalErrorIdentifier(
        ArchipadTechnicalErrorModule.PROJECT,
        "VISIT_TYPE_SYSTEM_MISSING",
    );

    constructor(localizationService: LocalizationService) {
        super(
            localizationService.l("Unexpected error"),
            [
                localizationService.l(
                    "If the problem persists, please contact support team with the following information:",
                ),
                VisitTypeSystemMissingError.identifier.toString(),
            ],
            AlertErrorAction.BACK_TO_PROJECT_LIST,
        );
    }
}
